<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier {{ type }} </strong>
          </div>
          <b-row class="mt-3">
            <b-col v-if="type === 'cheque'" sm="4">
              <b-form-group label="Montant" label-for="montant">
                <b-form-input id="montant" type="text" :class="{hasError: errors.montant !== ''}" v-model="montant"></b-form-input>
                <span class="field-error">{{ errors.montant }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="SIREN" label-for="siren">
                <b-form-input id="siren" type="text" :class="{hasError: errors.siren !== ''}" v-model="siren"></b-form-input>
                <span class="field-error">{{ errors.siren }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Gestionnaire" label-for="gestionnaire">
                <b-form-select
                  id="gestionnaire"
                  :plain="true"
                  :options="gestionnairesOptions"
                  v-model="gestionnaire">
                </b-form-select>
                <span class="field-error">{{ errors.gestionnaire }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="4">
              <b-form-group label="Statut" label-for="statut">
                <b-form-select
                  id="statut"
                  :plain="true"
                  :options="statutsOptions"
                  v-model="statut"
                ></b-form-select>
                <span class="field-error">{{ errors.statut }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Numéro TP" label-for="numeroTP">
                <b-form-input id="numeroTP" type="text" :class="{hasError: errors.numeroTP !== ''}" v-model="numeroTP"></b-form-input>
                <span class="field-error">{{ errors.numeroTP }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des reglements
            </b-button>
            <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Modifier
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'
  import {espaceRPARules, hasRule} from '../../../utils/rulesHelper'
  import IbanValidator from 'iban/iban.js';
  import moment from 'moment';

  export default {
    data() {
      return {
        type: '',
        rules: espaceRPARules,
        iban : '',
        initialesIban: '',
        siren: '',
        montant: '',
        dateExecution: '',
        EndToEndId: '',
        ustrd: '',
        ultmt: '',
        nomClient: '',
        gestionnaire: '',
        gestionnairesOptions: [],
        statut: '',
        statutsOptions: [
          { value:'Traité',
            text :'Encaissé sur NSI (Traité)'
          },
          { value :'Encaissé',
            text:'Encaissé sur NSI (Encaissé)'
          },
          { value :'Encaissé avec non-ventilé',
            text:'Encaissé sur NSI (Encaissé avec non-ventilé)'
          },
          { value :'Neutralisé',
            text:'Neutralisé'
          },
          { value :'En cours de traitement',
            text:'Non encaissé sur NSI (En cours de traitement)'
          },
          { value :'En attente de traitement',
            text:'Non ecaissé sur NSI (En attente de traitement)'
          },
          { value :'En attente d\'envoi à la banque',
            text:'Non ecaissé sur NSI (En attente d\'envoi à la banque)'
          }
        ],
        avisAppel: '',
        montantNonVentile: '',
        raisonBlocage: '',
        numeroTP: '',
        DatePickerFormat: 'dd/MM/yyyy',
        errors: {
          iban: '',
          initialesIban: '',
          siren: '',
          montant: '',
          dateExecution: '',
          EndToEndId: '',
          ustrd: '',
          ultmt: '',
          nomClient: '',
          gestionnaire: '',
          statut: '',
          avisAppel: '',
          montantNonVentile: '',
          raisonBlocage: '',
          numeroTP: '',
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.type = this.$route.query.type;
      this.getReglementById();
      this.getGestionnaires();
    },
    methods: {
      getReglementById() {
        this.$axios
          .get(`/espaceRPA/reglements/edit/${this.type}/${this.$route.params.id}`)
          .then(response => {
            this.siren = response.data.reglement.siren;
            this.montant = response.data.reglement.montant;
            this.gestionnaire = response.data.reglement.gestionnaire;
            this.statut = response.data.reglement.statut;
            this.numeroTP = response.data.reglement.numero_tp;
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      canAccess(rule) {
        return hasRule(rule)
      },
      getGestionnaires(){
        this.$axios
          .get("/espaceRPA/reglements/gestionnaires/list")
          .then(response => {
            let gestionnaires = response.data.gestionnaires;
            for (let key in gestionnaires){
              if (this.gestionnairesOptions.indexOf(gestionnaires[key].nom) < 0){
                this.gestionnairesOptions.push({
                  text: gestionnaires[key].nom,
                  value: gestionnaires[key].nom
                });
              }
            }
            this.gestionnairesOptions.sort();
          })
          .catch(function(error) {});
      },
      edit() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let dataPost = {};
          dataPost.siren = this.siren;
          dataPost.amt = this.montant.replace(/ /g, "").replace(/\./g, ",");
          dataPost.gestionnaire = this.gestionnaire;
          dataPost.statut = this.statut;
          dataPost.numerotp = this.numeroTP;
          this.$axios
            .put(`/espaceRPA/reglements/update/${this.type}/${this.$route.params.id}`, dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title:'Modification avec succès',
                text:'Le règlement a bien été modifié',
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack();
            })
            .catch(function(error) {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title:'Attention !!',
                text:'Un problème est survenu, merci de contacter le support',
                showConfirmButton: false,
                timer: 5000
              })
            });
        }
      },
      returnBack() {
        this.$router.push({ path: '/suivi-cotisations/reglements/list' })
      },
      validateData () {
        this.clearErrors();
        this.siren = this.siren.replace(/\s/g, '');
        let valid = true;
        if (this.siren === "") {
          this.errors.siren = "Le SIREN est obligatoire";
          valid= false;
        }
        else if (this.siren.length !== 9) {
          valid = false;
          this.errors.siren  = 'Veuillez entrer un SIREN de 9 chiffres'
        }
        else{
          if(this.checkSiren() === false){
            valid = false;
            this.errors.siren  = 'Le SIREN est invalide.'
          }
        }
        let montant = this.montant.replace(/ /g, "").replace(/,/g, ".");
        if (montant === '') {
          this.errors.montant = "Le montant est obligatoire";
        }
        else if(isNaN(montant)) {
          this.errors.montant = 'Le montant doit contenir que des chiffres'
          valid = false
        }
        else if (montant.length > 15) {
          this.errors.montant = 'Le montant saisi est invalide'
          valid = false
        }
        if (this.numeroTP === '') {
          this.errors.numeroTP = "Le N° TP est obligatoire";
          valid = false;
        }
        else if (this.numeroTP.length > 8) {
          this.errors.numeroTP = 'Le N° TP saisi est invalide';
          valid = false;
        }
        let gestionnaire = this.gestionnaire.replace(/ /g, "");
        if (gestionnaire === "") {
          this.errors.gestionnaire = "Le gestionnaire est obligatoire";
          valid= false;
        }
        let statut = this.statut.replace(/ /g, "");
        if (this.statut === "") {
          this.errors.statut = "Le statut est obligatoire";
          valid= false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.siren = "";
        this.errors.montant = "";
        this.errors.gestionnaire = "";
        this.errors.statut = "";
        this.errors.numeroTP = "";
      },
      checkSiren(){
        let siren = this.siren;

        if ( (siren.length != 9) || (isNaN(siren)) )
          return false;
        else {
          var somme = 0;
          var tmp;
          for (var cpt = 0; cpt<siren.length; cpt++) {
            if ((cpt % 2) == 1) { // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
              tmp = siren.charAt(cpt) * 2; // On le multiplie par 2
              if (tmp > 9)
                tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
            }
            else
              tmp = siren.charAt(cpt);
            somme += parseInt(tmp);
          }
          if ((somme % 10) == 0)
            return true;
          else
            return  false;
        }
        return false;
      }
    }
  }
</script>
